import React, { Component } from "react";
import { withParams } from "./../utils/hoc";
import { loginUser } from "./../actions/authActions";
import { connect } from "react-redux";
import TextFieldGroup from "./../commons/TextFieldGroup";
import DeveloperFooter from "./../utils/DeveloperFooter";
import logo from "./../images/logo.jpeg";
import axios from "axios";

import { Form, Button } from "antd";

class LoginForm extends Component {
  state = {
    errors: {},
    username: "",
    password: "",
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    if (e) e.preventDefault();

    const form_data = {
      username: this.state.username,
      password: this.state.password,
    };

    this.props.loginUser(form_data, this.props.navigate);
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.errors !== this.props.errors) {
      this.setState({ errors: this.props.errors });
    }
  }

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.props.navigate("/cashier");
    }
  }

  render() {
    const { errors } = this.state;
    return (
      <div className="container">
        <div className="columns">
          <div
            className="column box is-half is-offset-one-quarter"
            style={{ padding: "2rem", marginTop: "6rem" }}
          >
            <div
              className="has-text-centered has-text-weight-bold is-size-4"
              style={{ paddingTop: "3rem", paddingBottom: "4rem" }}
            >
              <img src={logo} alt="logo" style={{ width: 150 }} />
              <br />
            </div>

            <Form
              layout="vertical"
              onFinish={() => {
                this.onSubmit();
              }}
            >
              <TextFieldGroup
                label="Username"
                error={errors.username}
                name="username"
                value={this.state.username}
                onChange={this.onChange}
                className="no-transform"
              />

              <TextFieldGroup
                type="password"
                label="Password"
                error={errors.password}
                name="password"
                value={this.state.password}
                onChange={this.onChange}
                onPressEnter={(e) => {
                  this.onSubmit();
                }}
                className="no-transform"
              />

              <Form.Item style={{ marginTop: "24px" }}>
                <input
                  type="submit"
                  value="Log in"
                  className="button is-primary"
                />
              </Form.Item>
              <DeveloperFooter />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.errors,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { loginUser })(withParams(LoginForm));
